/*
* @Author: gujianghua
* @Date:   2020-05-06 19:15:54
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-05-19 18:18:17
*/
import { service } from '@/utils/request'

export default {
	//保存
	getDataList(data) {
	  	return service({
		    url: '/cloud/uac/twebpage/findByList',
		    method: 'get',
		    params: data
	  	})
	},
	save(data) {
		return service({
		    url: '/cloud/uac/twebpage/save',
		    method: 'post',
		    data: data
	  	})
	},
	deleteData(data) {
		return service({
		    url: '/cloud/uac/twebpage/del',
		    method: 'post',
		    params: data
	  	})
	},
	getById(path) {
		return service({
		    url: '/cloud/uac/twebpage/get/' + path,
		    method: 'get'
	  	})
	},
}


// WEBPACK FOOTER //
// ./src/api/operateManage/pagemanage.js